<template>
    <v-card width="80" class="py-10px">
        <div class="d-block font-size-12 font-weight-medium text-center pb-10px">최근 본 상품</div>
        <template v-for="product in recentProducts">
            <v-card tile elevation="0" :key="product._id" :to="`/shop/products/${product._id}`">
                <v-img :src="product.thumb" contain width="72" height="72" class="my-2 mx-auto"/>
            </v-card>
        </template>
    </v-card>
</template>
<script>
export default {
    computed: {
        recentProducts(){ return this.$store.state.recentProducts || [] }
    }
}
</script>